import { useMemo } from 'react'
import { observer } from 'mobx-react-lite'
import { Typography, SpinnerLoader, EmptyState, EnumSpinnerLoaderPosition } from 'shared/ui'
import { Table } from 'shared/ui/TableNew'
import { useAuthorizedAppsViewContext } from 'pages/settings/pages/developer/pages/authorizedApps/context/authorizedAppsViewContext'
import { authorizedAppsTableColumns } from 'pages/settings/pages/developer/pages/authorizedApps/ui/AuthorizedAppsTable/authorizedAppsTableColumns'
import { getAuthorizedAppsTableActions } from 'pages/settings/pages/developer/pages/authorizedApps/ui/AuthorizedAppsTable/getAuthorizedAppsTableActions'
import styles from './styles.module.scss'

export const AuthorizedAppsPage = observer(() => {
  const store = useAuthorizedAppsViewContext()
  const isEmpty = !store.loading && store.tokens.length === 0

  const rows = useMemo(() => {
    return store.items.map((item) => {
      item.setActionsProps({
        actions: getAuthorizedAppsTableActions(item, store),
      })
      item.setAriaLabel('AuthorizedAppRow')
      return item
    })
  }, [store.items, store])

  if (store.loading) {
    return (
      <div className={styles.loaderWrapper}>
        <SpinnerLoader
          ariaLabel={'AuthorizedAppsPage'}
          position={EnumSpinnerLoaderPosition.Absolute}
          size={32}
        />
      </div>
    )
  }

  if (isEmpty) {
    return (
      <div className={styles.content}>
        <div className={styles.emptyWrapper}>
          <section className={styles.empty} aria-label='Authorized Apps empty state'>
            <EmptyState
              iconProps={{
                icon: 'container',
                color: 'var(--content-brand-primary)',
                fontSize: 42,
              }}
              title={
                <Typography
                  variant='heading-lg'
                  ariaLabel='Authorized Apps empty state title'
                  tag='div'
                  marginBottom={3}
                >
                  Authorized Apps
                </Typography>
              }
              text='Apps you connect using OAuth will appear here once access is granted.'
              typographyProps={{
                variant: 'body-lg-regular',
                color: 'var(--content-primary-tertiary)',
                ariaLabel: 'Authorized Apps empty state text',
              }}
              boxProps={{
                gap: '32px',
                width: '360px',
                height: 'unset',
                textAlign: 'center',
              }}
            />
          </section>
        </div>
      </div>
    )
  }

  return (
    <div className={styles.content}>
      <div className={styles.header}>
        <div className={styles.headerLeft}>
          <Typography variant='heading-lg' ariaLabel='Authorized Apps title'>
            Authorized Apps
          </Typography>
          <Typography
            variant='body-md-regular'
            ariaLabel='Authorized Apps desc'
            color='var(--content-primary-tertiary)'
          >
            Manage apps that have access to your Salesmsg account
          </Typography>
        </div>
      </div>

      <div className={styles.tokensContent}>
        <Table
          ariaLabel={'AuthorizedAppsTable'}
          store={store.tableStore}
          columns={authorizedAppsTableColumns}
          rows={rows}
          loading={false}
          hidePagination
          defaultColumnCellStyle={{
            height: '41.5px',
            maxHeight: '41.5px',
            minHeight: '41.5px',
            paddingTop: 0,
            paddingBottom: 0,
            paddingLeft: '4px',
            lineHeight: '41.5px',
          }}
        />
      </div>
    </div>
  )
})
